export default "__VITE_ASSET__BWksmB10__"